import React, { useContext } from "react";
import "./WorkExperience.scss";
import ExperienceCard from "../../components/experienceCard/ExperienceCard";
import { workExperiences } from "../../portfolio";
import { Fade } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import { useTranslation } from "react-i18next";

export default function WorkExperience() {
  const { isDark } = useContext(StyleContext);
  const { t } = useTranslation();

  if (!workExperiences.display) return null;

  const translatedJobs = t("experience.jobs", { returnObjects: true });

  return (
    <div id="experience">
      <Fade bottom duration={1000} distance="20px">
        <div className="experience-container" id="workExperience">
          <div>
            <h1 className="experience-heading">{t("experience.title")}</h1>
            <div className="experience-cards-div">
              {translatedJobs.map((job, i) => (
                <ExperienceCard
                  key={i}
                  isDark={isDark}
                  cardInfo={{
                    company: job.company,
                    desc: job.desc,
                    date: job.date,
                    companylogo: workExperiences.experience[i].companylogo,
                    role: job.role,
                    descBullets: job.bullets
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
}
